/**
 * Copyright 2026 Salesforce, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { type ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import LegalLinks from './legal-links';

export default function CheckoutFooter(): ReactElement {
    const { t } = useTranslation('footer');
    return (
        <footer className="mt-auto border-t border-border">
            <div className="section-container py-4">
                <div className="flex flex-col sm:flex-row justify-between items-center gap-2 text-sm text-muted-foreground">
                    <div>
                        © {t('logoAlt')} {t('address')}
                    </div>
                    <LegalLinks />
                </div>
            </div>
        </footer>
    );
}
